import { Cookie } from '@/Cookie';
import { ICart, IRootState, ICartCourse, ICourseStudentWrapper, ICoupon } from '@/interfaces';
import { Module } from 'vuex';
import { CartGetters, UserGetters } from '@/Getters';
import { AjaxHelper } from '@/AjaxHelper';

export const cartStore: Module<ICart, IRootState> = {
  state: {
    cartItems: Cookie.getJson('CartSession') ?? [],
    coupon: Cookie.getJson('CartCoupon') ?? null
  },
  getters: {
    [CartGetters.getCourses]: state => state.cartItems,
    [CartGetters.getCoupon]: state => state.coupon
  },
  mutations: {
    setCartItems (state, courses?: ICartCourse[]) {
      state.cartItems = courses ?? [];
      Cookie.setJson('CartSession', state.cartItems);
    },
    setCoupon (state, coupon: ICoupon | null) {
      state.coupon = coupon;
      Cookie.setJson('CartCoupon', state.coupon);
    }
  },
  actions: {
    async loadCart({ commit }) {
      const cart = await AjaxHelper.get<ICart>('/shoppingcartmanagement');
      commit('setCartItems', cart.cartItems);
      commit('setCoupon', cart.coupon);
      return true;
    },
    async saveCart({ state, getters }) {
      if (state.cartItems.length > 0 && getters[UserGetters.isAuthenticated]) {
        await AjaxHelper.post('/shoppingcartmanagement', { cartItems: state.cartItems, coupon: state.coupon });
        return true;
      }
      return false;
    },
    async addCourseToCart ({ commit, state, getters }, course: ICartCourse) {
      const courses = state.cartItems;
      if (courses.findIndex(x => x.moodleId === course.moodleId) === -1) {
        if (getters[UserGetters.isAuthenticated]) {
          await AjaxHelper.post('/shoppingcartitemmanagement', course);
        }
        courses.push({ moodleId: course.moodleId, fullName: course.fullName, studentSessions: [] });
        commit('setCartItems', courses);
        return true;
      }
      return false;
    },
    async removeCourseFromCart({ commit, state, getters }, course: ICartCourse) {
      const courses = state.cartItems;
      const index = courses.findIndex(x => x.moodleId === course.moodleId);
      if (index > -1) {
        if (getters[UserGetters.isAuthenticated]) {
          await AjaxHelper.delete(`/shoppingcartitemmanagement?courseId=${course.moodleId}`);
        }
        courses.splice(index, 1);
        commit('setCartItems', courses);
        return true;
      }
      return false;
    },
    async addStudentToCourseItem({ commit, state, getters }, data: ICourseStudentWrapper) {
      const courses = state.cartItems;
      const index = courses.findIndex(x => x.moodleId === data.course.moodleId);
      if (index > -1 && courses[index].studentSessions.findIndex(x => x.studentId === data.student.studentId) === -1) {
        if (getters[UserGetters.isAuthenticated]) {
          await AjaxHelper.post('/ShoppingCartItemStudentManagement', { moodleCourseId: data.course.moodleId, studentId: data.student.studentId });
        }
        courses[index].studentSessions.push(data.student);
        commit('setCartItems', courses);
        return true;
      }
      return false;
    },
    async updateStudentToCourseItem({ commit, state, getters }, data: ICourseStudentWrapper) {
      const courses = state.cartItems;
      const index = courses.findIndex(x => x.moodleId === data.course.moodleId);
      if (index > -1) {
        const studentIndex = courses[index].studentSessions.findIndex(x => x.studentId === data.student.studentId);
        if (studentIndex > -1) {
          if (getters[UserGetters.isAuthenticated]) {
            await AjaxHelper.put('/ShoppingCartItemStudentManagement', { moodleCourseId: data.course.moodleId, studentId: data.student.studentId, sessionId: data.student.sessionId, priceTierId: data.student.priceTierId });
          }
          courses[index].studentSessions.splice(studentIndex, 1, data.student);
          commit('setCartItems', courses);
          return true;
        }
      }
      return false;
    },
    async removeStudentFromCourseItem({ commit, state, getters }, data: ICourseStudentWrapper) {
      const courses = state.cartItems;
      const index = courses.findIndex(x => x.moodleId === data.course.moodleId);
      if (index > -1) {
        const sIndex = courses[index].studentSessions.findIndex(x => x.studentId === data.student.studentId);
        if (sIndex > -1) {
          if (getters[UserGetters.isAuthenticated]) {
            await AjaxHelper.delete(`/ShoppingCartItemStudentManagement?moodleCourseId=${data.course.moodleId}&studentId=${data.student.studentId}`);
          }
          courses[index].studentSessions.splice(sIndex, 1);
          commit('setCartItems', courses);
          return true;
        }
      }
      return false;
    },
    async applyCoupon({ commit, state, getters }, data: ICoupon | null) {
      if (state.coupon !== data) {
        if (getters[UserGetters.isAuthenticated]) {
          await AjaxHelper.put('/shoppingcartmanagement/coupon', data);
        }
        state.coupon = data;
        commit('setCoupon', data);
      }
      return true;
    }
  }
}